import { render, staticRenderFns } from "./improveData.vue?vue&type=template&id=c95cdde2&scoped=true"
import script from "./improveData.vue?vue&type=script&lang=js"
export * from "./improveData.vue?vue&type=script&lang=js"
import style0 from "./improveData.vue?vue&type=style&index=0&id=c95cdde2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95cdde2",
  null
  
)

export default component.exports